<app-dialog-wrapper>
  <div class="flex flex-col flex-1 w-full">
    <!-- ⚡ on neutralise le h-[100dvh] du StripeWebComponent avec un conteneur -->
    <app-stripe-web [data]="data" class="flex-1 w-full"></app-stripe-web>
  </div>
</app-dialog-wrapper>
